<template>
    <div class="emp-header-mobile">
        <div class="emp-header-mobile-container">
            <!-- Hamburger Menu Icon -->
            <div class="emp-header-mobile-hamburger" @click="toggle_sidebar">
                <feather class="hamburger-icon" type="menu" id="mobile-sidebar-toggle"></feather>
            </div>
            
            <!-- Logo Section -->
            <div class="emp-header-mobile-logo">
                <router-link to="/" class="emp-header-mobile-logo-link" custom v-slot="{ navigate }">
                    <a href="https://www.chinaplasonline.com/eMarketplace/simp" @click="navigate($event)">
                        <img :src="LogoPath" class="emp-header-mobile-logo-img" alt="CPS+ eMarketplace" />
                    </a>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmpHeaderMobile',
    computed: {
        langid() {
            return localStorage.getItem("currentLangId");
        },
        LogoPath() {
            const locale =
                this.langid == "936" ? "sc" : this.langid == "950" ? "tc" : "en";
            const logoEndPoint = `/EMP_logos_${locale}.png?x-oss-process=image/format,webp`;

            return "https://cdn.adsalecdn.com/EMP/2-0/images" + logoEndPoint;
        },
    },
    methods: {
        toggle_sidebar() {
            this.$store.dispatch('menu/opensidebar');
        },
    },
};
</script>

<style scoped lang="scss">
.emp-header-mobile {
    --emp-mobile-header-height: 65px;
    background-color: #ffffff;
    width: 100%;
    min-height: var(--emp-mobile-header-height);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1100;
    border-bottom: 1px solid #e5e5e5;
    box-sizing: border-box;
    
    &-container {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        position: relative;
    }

    &-hamburger {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 16px;
        padding: 8px;
        transition: opacity 0.2s ease;

        &:hover {
            opacity: 0.7;
        }

        &:active {
            opacity: 0.5;
        }
    }

    &-logo {
        flex: 1;
        display: flex;
        align-items: center;

        &-link {
            display: flex;
            align-items: center;
            text-decoration: none;
        }

        &-img {
            max-height: 40px;
            width: auto;
            object-fit: contain;
        }
    }
}

.hamburger-icon {
    width: 24px;
    height: 24px;
    stroke: #4a4a4a;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
}

/* Responsive adjustments */
@media screen and (max-width: 991px) {
    .emp-header-mobile {
        display: block;
    }
}

@media screen and (min-width: 992px) {
    .emp-header-mobile {
        display: none;
    }
}
</style>
